<template lang="pug">
.v-section-top.section-top(v-if="data" ref="section")
	.section-top__left
		img.section-top__logo(
			v-if="data.image"
			:src="data.image?.src"
			:alt="data.image?.alt")
		.section-top__title(v-if="data.title && !isSm")
			.section-top__title-wrap
				span.section-top__title-strong(v-if="data.title.strong") {{ `${data.title.strong} ` }}
				span.section-top__title-text(v-if="data.title.text") {{ data.title.text }}
	.section-top__right(v-if="data.items" )
		v-section-top-card.section-top__card(
			v-for="(card, index) in data.items"
			:key="index"
			:data-source="card")
	.section-top__title(v-if="data.title && isSm")
		.section-top__title-wrap
			span.section-top__title-strong(v-if="data.title.strong") {{ `${data.title.strong} ` }}
			span.section-top__title-text(v-if="data.title.text") {{ data.title.text }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.$nextTick(() => {
				if(!this.isSm) {
					gsap.to(".section-top__right", {
						scrollTrigger: {
							trigger: '.section-top__right',
							start: 'top 14px',
							end: "bottom bottom",
							scrub: true,
							markers: false,
							pin: '.section-top__left'
						},
						yPercent: -1,
						duration: 1
					});
				}
				gsap.fromTo(".section-top__title-wrap",
					{
						opacity: 0,
						y: 200
					},
					{
						opacity: 1,
						y: 0,
						duration: 1,
					});
			})
		},
	},
}
</script>